export default __webpack_public_path__ + "static/media/raisut.7ee99d56.png";